import { Directive, ElementRef, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appDrawAfterRender]'
})
export class DrawAfterRenderDirective {
  private rendered: boolean = false;

  constructor(private el: ElementRef) { }

  @Output() drawReady: EventEmitter<any> = new EventEmitter();

  ngAfterViewChecked(): void {
    if (!this.rendered) {
      this.drawReady.emit();
      this.rendered = true;
    }
  }
}
